var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/cheerio/~/lodash/_Symbol.js
// module id = 583
// module chunks = 0